"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable no-unused-expressions */
var d3_1 = require("d3");
var coordinate_1 = require("./coordinate");
var svg_helper_1 = require("../lib/svg-helper");
var get_category_index_1 = require("../lib/get-category-index");
// 轴线与字体间距
var TEXT_GAP = 12;
/**
 * 直角坐标系
 * @since 2.0
 *
 * @todo 支持多轴
 */
var RectCoordinate = /** @class */ (function (_super) {
    tslib_1.__extends(RectCoordinate, _super);
    function RectCoordinate(ctx, helpers) {
        var _this = _super.call(this, ctx, helpers) || this;
        /**
         * 分类轴数据比例尺类型
         * @since 2.0
         */
        _this.categoryScaleType = "Point";
        /**
         * X 轴的高度，根据是不是显示来控制
         * @since 2.0
         */
        _this.xAxisHeight = 24;
        var _a = _this.ctx, root = _a.root, classPrefix = _a.classPrefix;
        _this.xAxisGrid = root
            .append("g")
            .attr("class", classPrefix + "-chart-axis " + classPrefix + "-chart-xaxis-grid")
            .attr("data-z-index", "1");
        _this.yAxisGrid = root
            .append("g")
            .attr("class", classPrefix + "-chart-axis " + classPrefix + "-chart-yaxis-grid")
            .attr("data-z-index", "1");
        _this.xAxis = root
            .append("g")
            .attr("class", classPrefix + "-chart-axis " + classPrefix + "-chart-xaxis")
            .attr("data-z-index", "2");
        _this.yAxis = root
            .append("g")
            .attr("class", classPrefix + "-chart-axis " + classPrefix + "-chart-yaxis")
            .attr("data-z-index", "2");
        _this.xAxisLabels = root
            .append("g")
            .attr("class", classPrefix + "-chart-axis-labels " + classPrefix + "-chart-xaxis-labels")
            .attr("data-z-index", "7");
        _this.yAxisLabels = root
            .append("g")
            .attr("class", classPrefix + "-chart-axis-labels " + classPrefix + "-chart-yaxis-labels")
            .attr("data-z-index", "7");
        _this.xAxisTitle = _this.xAxis
            .append("text")
            .attr("class", classPrefix + "-axis-title")
            .attr("data-z-index", 7)
            .attr("text-anchor", "middle")
            .attr("transform", "translate(0,0)");
        _this.yAxisTitle = _this.yAxis
            .append("text")
            .attr("class", classPrefix + "-axis-title")
            .attr("data-z-index", 7)
            .attr("text-anchor", "middle");
        // 监听选择事件，处理缩放事件
        _this.ctx.on("selection.end", _this.onZoomEvents, _this);
        return _this;
    }
    /**
     * 绘制坐标轴
     * @param valueScale 数据比例尺
     * @param categroryScale 分类比例尺
     * @param categoryScaleType 分类比例尺类型
     * @param invert 是否为坐标轴反转
     *
     * @since 2.0
     */
    RectCoordinate.prototype.draw = function (valueScale, categroryScale, categoryScaleType, invert) {
        var xAxisEnable = this.ctx.getOption("axis.xAxis.enable");
        var yAxisEnable = this.ctx.getOption("axis.yAxis.enable");
        var align = this.ctx.getOption("legend").align;
        var _a = this.ctx.theme.padding, right = _a.right, top = _a.top, bottom = _a.bottom, left = _a.left;
        this.categoryScale = categroryScale;
        this.valueScale = valueScale;
        this.categoryScaleType = categoryScaleType;
        this.invert = invert;
        this.xAxisHeight = xAxisEnable ? 24 : 0;
        // 更新整个坐标轴的高度和宽度
        this.width = parseInt(this.ctx.background.attr("width"), 10) - left - right;
        this.height =
            parseInt(this.ctx.background.attr("height"), 10) - bottom - top;
        if (align === "bottom") {
            this.height -= this.helpers.legend.height;
        }
        else if (align === "right") {
            this.width -= this.helpers.legend.width;
        }
        // 清除所有的栅格线和标签
        this.clearGrid();
        this.clearLabels();
        // 绘制标题
        this.drawTitles();
        // 绘制 Y 轴
        this.drawYAxis();
        var yAxisLabelWidth = yAxisEnable
            ? Math.round(svg_helper_1.nodeWidth(this.yAxisLabels.node())) + 14
            : 6;
        this.drawXAxis(yAxisLabelWidth);
        // 更新绘图区背景
        this.ctx.plotBackgound
            .attr("x", yAxisLabelWidth + left)
            .attr("y", top)
            .attr("height", Math.abs(this.height - this.xAxisHeight))
            .attr("width", Math.abs(this.width - yAxisLabelWidth));
        // 更新遮罩
        this.ctx.plotMask
            .attr("x", left + yAxisLabelWidth - 5)
            .attr("y", top - 5)
            .attr("height", Math.abs(this.height - this.xAxisHeight + 5))
            .attr("width", Math.abs(this.width - yAxisLabelWidth + 10));
    };
    /**
     * 绘制 Y 轴
     * @since 2.0
     * @todo 轴标题
     */
    RectCoordinate.prototype.drawYAxis = function () {
        var _a = this.ctx, classPrefix = _a.classPrefix, theme = _a.theme, top = _a.theme.padding.top;
        var xAxisEnable = this.ctx.getOption("axis.xAxis.enable", true);
        var yAxisOptions = this.ctx.getOption("axis.yAxis", {});
        var yScale = this.invert ? this.categoryScale[0] : this.valueScale;
        yScale.range([this.height + top - this.xAxisHeight, top]);
        // 修改左边距包含标题
        var titleHeight = svg_helper_1.nodeHeight(this.yAxisTitle.node());
        var fixTheme = Object.assign({}, theme);
        fixTheme.padding = Object.assign({}, theme.padding);
        fixTheme.padding.left =
            theme.padding.left + titleHeight > 0 ? titleHeight + 6 : 0;
        if (!yAxisOptions.enable)
            return;
        if (this.invert) {
            if (this.categoryScaleType === "Band") {
                this.categoryScale[1].range([0, yScale.bandwidth()]);
            }
            drawCategoryAxis(this.yAxisGrid, this.yAxisLabels, yScale, this.categoryScaleType, this.height - this.xAxisHeight, this.width, true, classPrefix, fixTheme, yAxisOptions);
        }
        else {
            drawValueAxis(this.yAxisGrid, this.yAxisLabels, yScale, this.height - this.xAxisHeight, this.width, false, classPrefix, fixTheme, yAxisOptions, !xAxisEnable);
        }
    };
    /**
     * 绘制 X 轴
     * @since 2.0
     */
    RectCoordinate.prototype.drawXAxis = function (yAxisLabelWidth) {
        var _a = this.ctx, classPrefix = _a.classPrefix, theme = _a.theme, left = _a.theme.padding.left;
        var xAixsOptions = this.ctx.getOption("axis.xAxis");
        var leftEdge = yAxisLabelWidth + left;
        var rightEdge = this.width + left;
        if (this.invert) {
            this.valueScale.range([leftEdge, rightEdge]);
            if (!xAixsOptions.enable)
                return;
            drawValueAxis(this.xAxisGrid, this.xAxisLabels, this.valueScale, this.height - this.xAxisHeight, this.width, true, classPrefix, theme, xAixsOptions);
        }
        else {
            var axisScale = void 0;
            if (this.categoryScaleType === "Point") {
                axisScale = this.categoryScale.range([
                    leftEdge,
                    rightEdge,
                ]);
            }
            else {
                axisScale = this.categoryScale[0].range([leftEdge, rightEdge]);
                this.categoryScale[1].range([0, axisScale.bandwidth()]);
            }
            if (!xAixsOptions.enable)
                return;
            drawCategoryAxis(this.xAxisGrid, this.xAxisLabels, axisScale, this.categoryScaleType, this.height - this.xAxisHeight, this.width, false, classPrefix, theme, xAixsOptions);
        }
    };
    /**
     * 处理缩放
     * @param start 选择区域的起始点 X 坐标
     * @param end 选择区域的终点 X 坐标
     */
    RectCoordinate.prototype.onZoomEvents = function (start, end) {
        var enable = this.ctx.getOption("interaction.zoom");
        if (enable) {
            var xScale = this.categoryScaleType === "Point"
                ? this.categoryScale
                : this.categoryScale[0];
            var domain = xScale.domain();
            var startIndex = get_category_index_1.getCategoryIndex(start, xScale, this.categoryScaleType);
            var endIndex = get_category_index_1.getCategoryIndex(end, xScale, this.categoryScaleType);
            var range = domain.slice(startIndex, endIndex + 1);
            this.ctx.emit("coord.zoom.zooming", range, start, end);
            this.ctx.emit("zoom.end", range[0], range[range.length - 1]);
            if (!this.zoomResetButton) {
                this.drawZoomResetButton();
            }
        }
    };
    /**
     * 绘制缩放重置的按钮
     *
     * @since 2.0
     */
    RectCoordinate.prototype.drawZoomResetButton = function () {
        var _this = this;
        var bgWidth = parseInt(this.ctx.background.attr("width"), 10);
        var _a = this.ctx, root = _a.root, classPrefix = _a.classPrefix;
        var resetText = this.ctx.getOption("interaction.zoom.resetText", "");
        this.zoomResetButton = root
            .append("g")
            .attr("class", classPrefix + "-chart-button " + classPrefix + "-chart-reset-zoom")
            .attr("data-z-index", "6")
            .attr("transform", "translate(" + (bgWidth - 84) + ", 10)")
            .on("click", function () {
            d3_1.event && d3_1.event.preventDefault();
            d3_1.event && d3_1.event.stopPropagation();
            _this.ctx.emit("coord.zoom.reset");
            _this.zoomResetButton.remove();
            _this.zoomResetButton = null;
        });
        this.zoomResetButton
            .append("rect")
            .attr("class", classPrefix + "-chart-button-box")
            .attr("fill", "#f2f2f2")
            .attr("stroke-width", 1)
            .attr("stroke", "#dddddd")
            .attr("height", 30)
            .attr("style", "cursor:pointer;");
        this.zoomResetButton
            .append("text")
            .attr("data-z-index", 1)
            .attr("style", "font-weight:normal;cursor:pointer;color:#000000;fill:#000000;font-size: 12px")
            .attr("x", 8)
            .attr("y", 20)
            .append("tspan")
            .text(resetText);
        var textWidth = svg_helper_1.getLabelMaxWidth(this.zoomResetButton.selectAll("text").nodes());
        this.zoomResetButton.select("rect").attr("width", textWidth + 16);
    };
    RectCoordinate.prototype.clearGrid = function () {
        var classPrefix = this.ctx.classPrefix;
        this.xAxisGrid.selectAll("." + classPrefix + "-chart-tick").remove();
        this.xAxisGrid.selectAll("." + classPrefix + "-chart-grid-line").remove();
        this.yAxisGrid.selectAll("." + classPrefix + "-chart-tick").remove();
        this.yAxisGrid.selectAll("." + classPrefix + "-chart-grid-line").remove();
    };
    RectCoordinate.prototype.clearLabels = function () {
        this.xAxisLabels.selectAll("text").remove();
        this.yAxisLabels.selectAll("text").remove();
    };
    RectCoordinate.prototype.drawTitles = function () {
        var xAixsOptions = this.ctx.getOption("axis.xAxis");
        var yAixsOptions = this.ctx.getOption("axis.yAxis");
        var left = this.ctx.theme.padding.left;
        this.xAxisTitle.selectAll("tspan").remove();
        this.yAxisTitle.selectAll("tspan").remove();
        if (xAixsOptions.title && xAixsOptions.title.text) {
            var size = svg_helper_1.textSize(xAixsOptions.title.text);
            drawAxisTitle(this.xAxisTitle, xAixsOptions.title.text, xAixsOptions.title.style, (this.width + left) / 2, this.height + this.xAxisHeight - size.height / 2);
            this.height -= this.helpers.legend.height;
        }
        if (yAixsOptions.title && yAixsOptions.title.text) {
            var size = svg_helper_1.textSize(yAixsOptions.title.text);
            drawAxisTitle(this.yAxisTitle, yAixsOptions.title.text, yAixsOptions.title.style, left + size.height, (this.height - size.height) / 2, true);
            this.height -= svg_helper_1.nodeHeight(this.xAxisTitle.node());
        }
    };
    return RectCoordinate;
}(coordinate_1.Coordinate));
exports.RectCoordinate = RectCoordinate;
/**
 * 绘制分类轴
 *
 * @since 2.0
 *
 * @param grid 轴的栅格线对象
 * @param labels 轴的标签对象
 * @param scale 轴的比例尺
 * @param scaleType 轴类型，Band 或者 Point
 * @param height 坐标轴的高度
 * @param width 坐标轴的宽度
 * @param vertical 是否是垂直方向
 * @param classPrefix 样式类前缀
 * @param theme 主题
 * @param options 轴选项
 */
function drawCategoryAxis(grid, labels, scale, scaleType, height, width, vertical, classPrefix, theme, options) {
    if (vertical === void 0) { vertical = false; }
    var _a = theme.xAxis, tickColor = _a.tickColor, tickLength = _a.tickLength, labelColor = _a.labelColor, labelFontSize = _a.labelFontSize, _b = theme.padding, left = _b.left, top = _b.top, right = _b.right;
    var offset = 14; // Y 轴标签右边距
    var maxLabelWidth = 0;
    var maxLabelHeight = 0;
    var texts = scale.domain().map(function (v, i) {
        var _a = options.axisLabel, axisLabel = _a === void 0 ? {} : _a;
        var text = axisLabel.formatter
            ? axisLabel.formatter(String(v), i, v)
            : String(v);
        // 顺便计算文本最大宽度与高度
        var _b = svg_helper_1.textSize(text), width = _b.width, textHeight = _b.height;
        var textWidth = width + offset;
        maxLabelWidth = textWidth > maxLabelWidth ? textWidth : maxLabelWidth;
        maxLabelHeight = textHeight > maxLabelHeight ? textHeight : maxLabelHeight;
        var position = scaleType === "Point" ? scale(v) : scale(v) + scale.bandwidth() / 2;
        return {
            text: text,
            position: position,
            height: textHeight,
            width: textWidth,
        };
    });
    var _c = options.axisTick, axisTick = _c === void 0 ? {} : _c;
    var interval = axisTick.interval;
    // 上一个标签文本的末端位置
    var lastLabelEndPos = 0;
    texts = texts.filter(function (_a, i) {
        var position = _a.position, textHeight = _a.height, textWidth = _a.width;
        if (interval)
            return i % interval === 0;
        var offset = vertical ? textHeight : textWidth;
        if (vertical) {
            if (i === 0 || position + offset < lastLabelEndPos) {
                lastLabelEndPos = position - offset / 2;
                return true;
            }
        }
        else if (i === 0 || position - offset > lastLabelEndPos) {
            lastLabelEndPos = position + offset / 2;
            return true;
        }
        return false;
    });
    var textNodes = labels
        .selectAll("text")
        .data(texts)
        .join("text")
        .attr("font-size", labelFontSize)
        .attr("fill", labelColor)
        .attr("text-anchor", function () {
        if (vertical)
            return "end";
        return "middle";
    })
        .attr("transform", "translate(0,0)")
        .attr("opacity", 1)
        .text(function (v) { return v.text; });
    textNodes
        .attr("x", function getX(_a, i) {
        var x = _a.position;
        if (vertical)
            return maxLabelWidth + left - offset;
        // 如果文本超出边界需要重定位
        var textWidth = svg_helper_1.nodeWidth(d3_1.select(this).node());
        if (i === 0) {
            if (x - textWidth / 2 < 0)
                return left + textWidth / 2 + 10;
        }
        else if (i === texts.length - 1) {
            if (x + textWidth / 2 > width + right)
                return x - textWidth / 2;
        }
        return x;
    })
        .attr("y", function (_a) {
        var y = _a.position;
        if (vertical) {
            return y + maxLabelHeight / 4;
        }
        return height + tickLength + offset + top;
    });
    grid
        .selectAll("." + classPrefix + "-chart-tick")
        .data(texts)
        .join("path")
        .attr("fill", "none")
        .attr("class", classPrefix + "-chart-tick")
        .attr("stroke", tickColor)
        .attr("stroke-width", 1)
        .attr("d", function (_a) {
        var position = _a.position;
        if (vertical) {
            return "M " + (maxLabelWidth + left) + " " + position + " L " + (maxLabelWidth +
                left -
                tickLength) + " " + position;
        }
        return "M " + position + " " + (height + top) + " L " + position + " " + (height +
            tickLength +
            top);
    });
}
/**
 * 绘制值轴
 *
 * @since 2.0
 *
 * @param grid 轴的栅格线对象
 * @param labels 轴的标签对象
 * @param scale 轴的比例尺
 * @param height 坐标轴的高度
 * @param width 坐标轴的宽度
 * @param vertical 是否是垂直方向
 * @param classPrefix 样式类前缀
 * @param theme 主题
 * @param options 轴选项
 * @param showFirstLabel 是否显示第一个标签
 */
function drawValueAxis(grid, labels, scale, height, width, vertical, classPrefix, theme, options, showFirstLabel) {
    if (vertical === void 0) { vertical = false; }
    if (showFirstLabel === void 0) { showFirstLabel = false; }
    var _a = theme.padding, left = _a.left, top = _a.top, _b = theme.yAxis, labelColor = _b.labelColor, labelFontSize = _b.labelFontSize, majorGridLineColor = _b.majorGridLineColor, gridLineColor = _b.gridLineColor, grindLineWidth = _b.grindLineWidth;
    var _c = options.axisTick, axisTick = _c === void 0 ? {} : _c;
    var interval = axisTick.interval;
    var maxLabelSize = 0; // 轴标签文本的最大尺寸，垂直轴时为宽度，水平轴时为高度
    // 计算最大尺寸
    var ticks = scale
        .domain()
        // 格式化
        .map(function (v, i) {
        var _a = options.axisLabel, axisLabel = _a === void 0 ? {} : _a;
        var label = d3_1.format(",")(v);
        var text = axisLabel.formatter
            ? axisLabel.formatter(label, i, v)
            : label;
        var _b = svg_helper_1.textSize(text), textWidth = _b.width, textHeight = _b.height;
        var size = vertical ? textWidth : textHeight;
        if (size + TEXT_GAP > maxLabelSize)
            maxLabelSize = size + TEXT_GAP;
        return text;
    });
    var filteredTicks = [];
    if (interval !== undefined) {
        filteredTicks = ticks.filter(function (_, i) {
            if (i === 0 || i === ticks.length - 1)
                return true;
            return i % interval === 0;
        });
    }
    else {
        var ticksLen = vertical
            ? Math.floor(width / maxLabelSize)
            : Math.floor(height / maxLabelSize);
        if (ticksLen > 5) {
            ticksLen = 5;
        }
        else if (ticksLen < 1) {
            ticksLen = 1;
        }
        filteredTicks = scale.nice(ticksLen).ticks(ticksLen);
    }
    grid
        .selectAll("." + classPrefix + "-chart-grid-line")
        .data(filteredTicks)
        .join("path")
        .attr("class", classPrefix + "-chart-grid-line")
        .attr("fill", "none")
        .attr("stroke", function (_, i) {
        var color = i === 0 ? majorGridLineColor : gridLineColor;
        return color;
    })
        .attr("stroke-width", grindLineWidth)
        .attr("d", function (v) {
        var pos = scale(v);
        if (vertical)
            return "M " + pos + " " + top + " L " + pos + " " + (height + top);
        return "M " + left + " " + pos + " L " + (width + left) + " " + pos;
    });
    labels
        .selectAll("text")
        .data(filteredTicks)
        .join("text")
        .attr("font-size", labelFontSize)
        .attr("fill", labelColor)
        .attr("text-anchor", function (_, i) {
        if (vertical) {
            return i === filteredTicks.length - 1 ? "end" : "middle";
        }
        return "start";
    })
        .attr("transform", "translate(0,0)")
        .attr("opacity", function (_, i) {
        return i !== 0 || showFirstLabel || vertical ? 1 : 0;
    })
        .attr("x", function (v) {
        if (vertical)
            return scale(v);
        return 4 + left;
    })
        .attr("y", function (v) {
        if (vertical)
            return height + top + 14;
        var offset = showFirstLabel ? 4 : 12;
        return scale(v) + offset;
    })
        .text(function (v, i) {
        var _a = options.axisLabel, axisLabel = _a === void 0 ? {} : _a;
        var label = d3_1.format(",")(v);
        var text = axisLabel.formatter
            ? axisLabel.formatter(label, i, v)
            : label;
        return text;
    });
}
/**
 * 绘制标题
 *
 * @since 2.3
 *
 * @param title 标题对象
 * @param text 标题文本
 * @param vertical 是否为垂直
 */
function drawAxisTitle(title, text, style, x, y, vertical) {
    if (style === void 0) { style = ""; }
    title
        .attr("x", x)
        .attr("y", y)
        .attr("style", "color:#666666;fill:#666666;" + style)
        .attr("transform", "translate(0,0) " + (vertical ? "rotate(270, " + x + ", " + y + ")" : ""))
        .append("tspan")
        .text(text);
}
//# sourceMappingURL=rect-coord.js.map